<template>
<div>
    <!-- Logo and Progress Bar Section -->
    <section class="section_logo-bar">
        <div class="logonav_wrap" >
            <div class="logonav_div">
                <a href="#" class="link-block-73 w-inline-block">
                    <img sizes="(max-width: 3696px) 100vw, 3696px" v-if="active_el === 1"
                         srcset="@/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-500.png 500w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-800.png 800w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-1080.png 1080w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-1600.png 1600w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-2000.png 2000w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-2600.png 2600w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-3200.png 3200w, @/assets/images/OhMyMeds_Logo.png 3696w" 
                         alt="" src="@/assets/images/OhMyMeds_Logo.png" loading="lazy" class="image-487">
                </a>
            </div>
        </div>
    </section>

    <!-- Thank You Section (shown after completion) -->

    <!-- Form Section -->
    <div class="form-wrapper">
        <div class="form-main-div">
            
            <!-- Slide 1: Welcome -->
            <div class="enroll-slide-1" v-if="active_el === 1">
                <div class="form-block w-form">
                    <form @submit.prevent="handleSubmit" id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get">
                        <div class="enroll-slide-1-div-3">
                            <img sizes="(max-width: 641px) 100vw, 641px" 
                                 srcset="@/assets/images/stepsimage_teledoc_nS-p-500.png 500w, @/assets/images/stepsimage_teledoc_nS.png 641w" 
                                 alt="" src="@/assets/images/stepsimage_teledoc_nS.png" loading="lazy" class="enroll-top-image">
                            
                            <div class="enroll-header-2">Get Approved Instantly!</div>
                            <p class="enroll-sub-2">The following questions will will be used by a board certified physician licensed in your state to help create a treatment plan for you. <strong>Please answer all questions accurately.</strong></p>
                            
                            <div class="enroll-3-things-div">
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_ohmy_meds.png" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">All Dosages Same Price</div>
                                </div>
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_ohmy_doc.png" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">Board-certified physicians</div>
                                </div>
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_ohmy_pharma.png" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">503A Pharmacy Partners</div>
                                </div>
                            </div>
                            
                            <div class="enroll-disclaimer-div _1st">
                                <label class="w-checkbox enroll-checkbox-field">
                                    <input type="checkbox" v-model="people.agreed_to_terms" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox top">
                                    <span class="enroll-checkbox-label w-form-label" for="checkbox-3">
                                        I Agree to {{ appName }}' <a :href="`${appMainWeb}/terms`" target="_blank" class="enroll-checkbox-link">Terms</a>, 
                                        <a :href="`${appMainWeb}/privacy`" target="_blank" class="enroll-checkbox-link">Privacy Policy</a> and consent to 
                                        <a :href="`${appMainWeb}/telehealth`" target="_blank" class="enroll-checkbox-link">Telehealth</a>
                                    </span>
                                </label>
                            </div>
                            
                            <div class="enroll-form-button-div">
                                <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button top w-button" value="Start my FREE visit -&gt;">
                            </div>
                        </div>
                    </form>
                    
                    <div class="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div class="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                </div>
            </div>

            <!-- Slide 2: Basic Information -->
            <div class="enroll-slide-8" v-if="active_el === 2">
                <div class="enroll-form-header-div">
                    <div class="enroll-form-header-text-2">Let's start with the Basics</div>
                </div>
                
                <div class="enroll-form-block update w-form">
                    <form @submit.prevent="handleSubmit" class="enroll-form update">
                        
                        <h1 class="form-question-text smaller a">Let's make sure we are licensed in your state</h1>
                        <select id="State-4" name="State-4" data-name="State 4" required v-model="people.state" class="select-field-16 form update w-select">
                            <option value="">State...</option>
                            <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                        </select>

                        <h1 class="form-question-text smaller a">Who do I have the pleasure of talking to?</h1>
                        <div class="enroll-form-field-wrap-div update">
                            <input class="text-field-59 update w-input" maxlength="256" name="name" data-name="Name" 
                                   v-model="people.first_name" placeholder="First Name" type="text" id="name">
                            <input class="text-field-59 update w-input" maxlength="256" v-model="people.last_name" 
                                   name="Last-name" data-name="Last Name" placeholder="Last Name" type="text" id="Last-name" required>
                        </div>

                        <h1 class="form-question-text smaller a">What was your gender at birth?</h1>
                        <div class="div-block-1893">
                            <label class="w-checkbox checkbox-field-24 male">
                                <input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" 
                                       :checked="people.gender === 'Male'" @change="updateGender('Male')" class="w-checkbox-input enroll-checkbox">
                                <span class="checkbox-label-25 w-form-label" for="checkbox-4">Male</span>
                            </label>
                            <label class="w-checkbox checkbox-field-24 female">
                                <input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" 
                                       :checked="people.gender === 'Female'" @change="updateGender('Female')" class="w-checkbox-input enroll-checkbox">
                                <span class="checkbox-label-25 w-form-label" for="checkbox-4">Female</span>
                            </label>
                        </div>

                        <h1 class="form-question-text smaller a">Please enter your email</h1>
                        <input class="text-field-59 email form update w-input" maxlength="256" v-model="people.email" 
                               name="Email-2" data-name="Email 2" placeholder="Enter your email" type="email" id="Email-2" required>

                        <div class="enroll-disclaimer-div-2 form">
                            <label class="w-checkbox enroll-checkbox-field-2 form">
                                <input type="checkbox" v-model="people.agreed_to_email" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox">
                                <span class="enroll-checkbox-label-3 form w-form-label" for="checkbox-3">
                                    I agree to receive doctor correspondence, transactional and/or marketing messaging from {{ appName }} to the email address that I provided above.
                                </span>
                            </label>
                        </div>

                        <h1 class="form-question-text smaller a">Please enter your mobile number</h1>
                        <div class="phone-entry-div update">
                            <input class="phone-number-field-3 _1 form update w-input" @input="handlePhoneInput($event, 'areaCode')" 
                                   pattern="[0-9]*" ref="areaCode" maxlength="3" name="field-2" data-name="Field 2" 
                                   placeholder="(000)" v-model="people.phone_parts.areaCode" type="tel" id="field-2" required>
                            <div class="text-block-1540">-</div>
                            <input class="phone-number-field-3 form update w-input" @input="handlePhoneInput($event, 'prefix')" 
                                   pattern="[0-9]*" ref="prefix" maxlength="3" name="field-2" data-name="Field 2" 
                                   placeholder="000" type="text" v-model="people.phone_parts.prefix" id="field-2" required>
                            <div class="text-block-1540">-</div>
                            <input class="phone-number-field-3 _2 form update w-input" @input="handlePhoneInput($event, 'line')" 
                                   pattern="[0-9]*" ref="line" maxlength="4" name="field-2" data-name="Field 2" 
                                   placeholder="0000" type="text" v-model="people.phone_parts.line" id="field-2" required>
                        </div>

                        <h1 class="form-question-text smaller a">Can we send you text messages about your prescription?</h1>
                        <div class="text-block-1018">(including tracking information and refill information)</div>
                        <div class="enroll-form-field-wrap-div update bottom">
                            <label class="w-checkbox checkbox-field-4 update">
                                <input type="checkbox" :checked="people.agreed_to_text === 'Yes'" @change="updateAgreement('Yes')" 
                                       name="checkbox-2" id="checkbox-2" data-name="Checkbox 2" class="w-checkbox-input checkbox">
                                <span class="checkbox-label-4 w-form-label" for="checkbox-2">Yes</span>
                            </label>
                            <label class="w-checkbox checkbox-field-4 update">
                                <input type="checkbox" name="checkbox-2" id="checkbox-2" :checked="people.agreed_to_text === 'No'" 
                                       @change="updateAgreement('No')" data-name="Checkbox 2" class="w-checkbox-input checkbox">
                                <span class="checkbox-label-4 w-form-label" for="checkbox-2">No</span>
                            </label>
                        </div>

                        <div class="enroll-disclaimer-div-2 form">
                            <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                            <label class="w-checkbox enroll-checkbox-field-2 form">
                                <input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" 
                                       class="w-checkbox-input enroll-checkbox" v-model="people.form_step2_agree">
                                <span class="enroll-checkbox-label-3 form w-form-label" for="checkbox-3">
                                    By checking this box, I also consent by electronic signature to receive phone calls and/or SMS text messages at the phone number(s) below, including my wireless number if provided. I understand these calls may be generated using an automated technology, pre-recorded voices and that data rates may apply. I understand that my consent is not required to buy goods/services and I may opt out at any time to avoid receiving calls or SMS text messages.
                                </span>
                            </label>
                        </div>
                        
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button-3 w-button" value="Next -&gt;">
                        
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>
                </div>

                <div class="enroll-form-back-link-div-2">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text-2">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Slide 3: Date of Birth -->
            <div class="enroll-slide-9" v-if="active_el === 3">
                <h1 class="form-question-text">What is your date of birth?</h1>
                <div class="enroll-form-block b w-form">
                    <form @submit.prevent="validateDOB" class="enroll-form b">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="_3-input-div">
                                <select id="field-4" name="field-4" data-name="Field 4" v-model="people.dob.mm" class="select-3rds w-select">
                                    <option value="">Month</option>
                                    <option value="01">January</option>
                                    <option value="02">February</option>
                                    <option value="03">March</option>
                                    <option value="04">April</option>
                                    <option value="05">May</option>
                                    <option value="06">June</option>
                                    <option value="07">July</option>
                                    <option value="08">August</option>
                                    <option value="09">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                                <input class="input-3rds w-input" maxlength="256" v-model="people.dob.dd" 
                                       name="field-3" data-name="Field 3" placeholder="Day" type="text" id="field-3" pattern="[0-9]*"  required>
                                <input class="input-3rds w-input" maxlength="256" v-model="people.dob.yyyy" 
                                       name="field-3" data-name="Field 3" placeholder="Year" type="text" id="field-3" pattern="[0-9]*"  required>
                            </div>
                        </div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button-3 b w-button" value="Next -&gt;">
                        
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>
                </div>

                <div class="enroll-form-back-link-div-2">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text-2">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Slide 4: Height and Weight -->
            <div class="enroll-slide-9" v-if="active_el === 4">
                <h1 class="form-question-text">What is your height and weight?</h1>
                <p class="enroll-form-question-sub-2">We'll use this to determine your Body mass Index (BMI) for diagnosis. remember, BMI is a measure of size - not health</p>
                
                <div class="enroll-form-block b w-form">
                    <form @submit.prevent="handleSubmit" class="enroll-form b">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 height top">
                                <input class="enroll-form-text-field height w-input" maxlength="256" v-model="people.height.foot" 
                                       @keyup="calculateBMI" name="feet" data-name="Feet" placeholder="Feet" type="text" id="feet" pattern="[0-9]*"  required>
                                <div class="field-label-text">ft.</div>
                                <input class="enroll-form-text-field height update w-input" maxlength="256" v-model="people.height.inches" 
                                       @keyup="calculateBMI" name="inches" data-name="Inches" placeholder="Inches" type="text" id="inches" pattern="[0-9]*"  required>
                                <div class="field-label-text last">in.</div>
                            </div>
                            
                            <div class="enroll-form-input-div mobile-entry form _2 weight">
                                <input class="enroll-form-text-field weight w-input" maxlength="256" name="weight-2" 
                                       v-model="people.weight" @keyup="calculateBMI" data-name="Weight 2" pattern="[0-9]*"  
                                       placeholder="Weight in pounds" type="text" id="weight-2" required>
                                <div class="field-label-text weight">lbs.</div>
                            </div>
                            
                            <div v-if="people.bmi" class="bmi-result">
                                Your BMI: {{ people.bmi.toFixed(1) }}
                            </div>
                        </div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button-3 b w-button" value="Next -&gt;">
                        
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>
                </div>

                <div class="enroll-form-back-link-div-2">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text-2">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Slide 5: Desired Weight -->
            <div class="enroll-slide-9" v-if="active_el === 5">
                <h1 class="form-question-text">What is your <strong>desired weight</strong>?</h1>
                
                <div class="enroll-form-block b update w-form">
                    <form @submit.prevent="handleSubmit" class="enroll-form b">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 weight">
                                <input class="enroll-form-text-field weight w-input" maxlength="256" name="Goal-Weight" 
                                       v-model="people.desired_weight" data-name="Goal Weight" pattern="[0-9]*" 
                                       placeholder="What is your goal weight in pounds?" type="text" id="Goal-Weight" required>
                                <div class="field-label-text weight">lbs.</div>
                            </div>
                        </div>
                        
                        <button type="submit" class="enroll-form-submit-button-3 b w-button" :disabled="isSubmitting">
                            <div v-if="isSubmitting">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                     style="margin: auto; background: none; display: block; shape-rendering: auto;" 
                                     width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" 
                                            stroke-dasharray="164.93361431346415 56.97787143782138">
                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" 
                                                          dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1">
                                        </animateTransform>
                                    </circle>
                                </svg>
                            </div>
                            <div v-else>
                                Start my FREE visit -&gt;
                            </div>
                        </button>
                        
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>
                </div>

                <div class="enroll-form-back-link-div-2">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text-2">&lt; Go Back</div>
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import state from "@/utils/state.json"
import {
    mapActions
} from 'vuex'

export default {
    name: 'WeightLossForm2',
    data() {
        return {
            allState: state,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            appName: process.env.VUE_APP_COMPANY || 'OhMy!Meds',
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            active_el: 1,
            tempvalue: '',
            formErrors: {},
            isSubmitting: false,
            showThankYou: false,
            
            people: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                phone_parts: {
                    areaCode: '',
                    prefix: '',
                    line: ''
                },
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agreed_to_email: true,
                desired_weight: '',
                state: '',
                agreed_to_terms: true,
                form_step2_agree: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                ip_address: '',
                age: '',
                tracking_session_id:'',
                user_agent:'',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
            }
        }
    },
    
    async mounted() {
        if (this.$route.query.sema) {
            await this.$store.dispatch('addSemaOffer', this.$route.query.sema);
        }
        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();
    },
    
    computed: {
        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },
        isValidPhone() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            return (
                areaCode?.length === 3 &&
                prefix?.length === 3 &&
                line?.length === 4 &&
                /^\d+$/.test(areaCode) &&
                /^\d+$/.test(prefix) &&
                /^\d+$/.test(line)
            );
        },
        phoneNumber() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            if (!this.isValidPhone) return '';
            return `${areaCode}${prefix}${line}`;
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },
        calculatedBMI() {
            if (this.people.weight && this.people.heightInInches) {
                const heightInInches = parseFloat(this.people.heightInInches);
                const weightInPounds = parseFloat(this.people.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
            return null;
        }
    },
    
    methods: {
        ...mapActions([
            'setCartVisibility'
        ]),
        
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        
        GoBack() {
            this.active_el--;
        },
        
        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            if (date > today) {
                return false;
            }

            return true;
        },
        
        validateDOB() {
            const {
                mm,
                dd,
                yyyy
            } = this.people.dob

            const paddedMonth = String(mm).padStart(2, '0');
            const paddedDay = String(dd).padStart(2, '0');

            if (!this.isValidDate(paddedMonth, paddedDay, yyyy)) {
                this.isError = true
                return
            }

            this.people.dobMMDDYYYY = `${paddedMonth}/${paddedDay}/${yyyy}`
            this.active_el++;
            this.isError = false
        },
        
        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches)
            const weightInPounds = parseInt(this.people.weight)
            this.people.bmi = (weightInPounds * 703) / (heightInInches * heightInInches)
            this.people.heightInInches = heightInInches;
        },
        
        updateAgreement(selectedValue) {
            this.people.agreed_to_text = this.people.agreed_to_text === selectedValue ? null : selectedValue;
        },
        
        updateGender(selectedGender) {
            this.people.gender = this.people.gender === selectedGender ? null : selectedGender;
        },
        
        validateStep1() {
            this.formErrors = {};
            if (!this.people.agreed_to_terms) {
                this.formErrors.terms = 'Please agree to the terms and conditions';
                return false;
            }
            try {
                if (window.tracking) {
                    window.tracking.event('questionnaire_start', {});
                }
            } catch (error) {
                console.log(error)
            }
            return true;
        },
        
        validateStep2() {
            this.formErrors = {};

            if (!this.people.state) {
                this.formErrors.state = 'Please select your state';
                return false;
            }

            if (!this.people.first_name || !this.people.last_name) {
                this.formErrors.name = 'Please enter your full name';
                return false;
            }

            if (!this.people.gender) {
                this.formErrors.gender = 'Please select your gender';
                return false;
            }

            if (!this.isValidEmail) {
                this.formErrors.email = 'Please enter a valid email address';
                return false;
            }

            if (!this.people.agreed_to_email) {
                this.formErrors.emailConsent = 'Please agree to receive email communications';
                return false;
            }

            if (!this.isValidPhone) {
                this.formErrors.phone = 'Please enter a complete, valid phone number';
                return false;
            }

            try {
                if (window.tracking) {
                    window.tracking.event('partial', {});
                }
            } catch (error) {
                console.log(error)
            }

            return true;
        },
        
        validateStep3() {
            this.formErrors = {};

            const foot = parseInt(this.people.height.foot);
            const inches = parseInt(this.people.height.inches);
            const weight = parseFloat(this.people.weight);

            if (isNaN(foot) || isNaN(inches) || foot < 4 || foot > 8 || inches < 0 || inches > 11) {
                this.formErrors.height = 'Please enter a valid height';
                return false;
            }

            if (isNaN(weight) || weight < 80 || weight > 700) {
                this.formErrors.weight = 'Please enter a valid weight';
                return false;
            }

            this.people.heightInInches = (foot * 12) + inches;
            this.people.bmi = this.calculatedBMI;

            try {
                if (window.tracking) {
                    window.tracking.event('bmi_confirmation', {});
                }
            } catch (error) {
                console.log(error)
            }

            return true;
        },

        validateStep4() {
            this.formErrors = {};

            const desiredWeight = parseFloat(this.people.desired_weight);
            const currentWeight = parseFloat(this.people.weight);

            if (isNaN(desiredWeight) || desiredWeight < 80 || desiredWeight > 700) {
                this.formErrors.desiredWeight = 'Please enter a valid desired weight';
                return false;
            }

            if (desiredWeight >= currentWeight) {
                this.formErrors.desiredWeight = 'Desired weight should be less than current weight';
                return false;
            }

            return true;
        },

        async handleSubmit() {
            if (["LA", "MS"].includes(this.people.state)) {
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "Unfortunately, our GLP Medical Weight Loss program is not yet available in your state. However, we're excited to announce that it will be launching next month!"
                    }
                });
                return false;
            }
            
            this.formErrors = {};
            let isValid = false;

            switch (this.active_el) {
                case 1:
                    isValid = this.validateStep1();
                    break;
                case 2:
                    isValid = this.validateStep2();
                    break;
                case 3:
                    isValid = true;
                    break;
                case 4:
                    isValid = this.validateStep3();
                    break;
                case 5:
                    isValid = this.validateStep4();
                    break;
            }

            if (!isValid) {
                return;
            }

            if (this.active_el < 5) {
                this.active_el++;
                return;
            }

            this.finalSubmit();
        },
        
        async finalSubmit() {
            try {
                if (this.people.dob.yyyy > 2006) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years. "
                        }
                    });
                    return false;
                }
                
                this.isSubmitting = true;
                this.people.phone = this.phoneNumber;
                this.people.user_agent = window.navigator.userAgent;
                
                if(window.trackingSessionId){
                    this.people.tracking_session_id = window.trackingSessionId;
                }
                
                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, this.people, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                })
                
                if (response.data.status === 'success') {
                    try {
                        if (window.tracking) {
                            window.tracking.event('questionnaire_end', {});
                        }
                    } catch (error) {
                        console.log(error)
                    }
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.$router.push({
                        name: 'reportPage',
                        query: {
                            'desiredWeight': this.people.desired_weight
                        }
                    });
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.formErrors.submission = 'There was an error submitting your form. Please try again.';
            } finally {
                this.isSubmitting = false;
            }
        },
        
        goBack() {
            if (this.active_el > 1) {
                this.active_el--;
            }
        },

        handlePhoneInput(event, field) {
            const value = event.target.value.replace(/\D/g, '');

            if (value.length == 10) {
                const areaCodeLength = 3;
                const prefixLength = 3;
                const lineLength = 4;

                this.people.phone_parts.areaCode = value.slice(0, areaCodeLength);
                this.people.phone_parts.prefix = value.slice(areaCodeLength, areaCodeLength + prefixLength);
                this.people.phone_parts.line = value.slice(areaCodeLength + prefixLength, areaCodeLength + prefixLength + lineLength);
            }
            
            const maxLength = {
                areaCode: 3,
                prefix: 3,
                line: 4
            } [field];

            this.people.phone_parts[field] = value.slice(0, maxLength);

            if (value.length >= maxLength) {
                const nextField = {
                    areaCode: 'prefix',
                    prefix: 'line'
                } [field];

                if (nextField) {
                    this.$refs[nextField]?.focus();
                }
            }
        },

        handleGenderSelection(gender) {
            this.people.gender = gender;
        }
    },
    
    watch: {
        calculatedBMI(newBMI) {
            this.people.bmi = newBMI;
        },
        active_el() {
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style scoped>
.bmi-result {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
}

.progress_step_div.current {
    background-color: #007bff;
    color: white;
}

input[type="text"],
input[type="number"],
input[type="tel"],
input[type="email"],
input[type="password"] {
  font-size: 20px !important;
}
</style>